// extracted by mini-css-extract-plugin
module.exports = {"summary":"AnalyticsSummaryBlock_summary__2KrDb","action":"AnalyticsSummaryBlock_action__2v6Za","dashboardButton":"AnalyticsSummaryBlock_dashboardButton__8aVnJ"};